import React, { forwardRef } from 'react';
import { Card } from 'react-bootstrap';

const Account = forwardRef((props, ref) => {
 return (
  <Card className="mb-3" id="account" ref={ref}>
   <Card.Header className="bg-light">
    <h5 className="mb-0">Cuenta</h5>
   </Card.Header>
   <Card.Body>
    <h6 className="text-primary">Elegibilidad</h6>
    <p className="fs-0 mb-0 fw-semi-bold">Para utilizar el servicio de Inmovilii, debe:</p>
    <ol type="1">
     <li>completar el proceso de registro;</li>
     <li>aceptar los Términos de uso; y</li>
     <li>proporcionar información de contacto verdadera, completa y actualizada.</li>
    </ol>
    <hr className="my-4" />
    <h6 className="text-primary">Aceptación de los Términos de uso</h6>
    <p className="mb-0 ps-3">
     Al registrarse en Inmovilii y hacer clic en el botón de "registrarse", acepta los Términos de uso y forma un acuerdo
     vinculante con nosotros. Si se registra en Inmovilii en nombre de una empresa u otra entidad, declara y garantiza tener la
     autoridad para aceptar estos Términos en su nombre.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Cierre de cuenta</h6>
    <p className="mb-0 ps-3">
     Tanto usted como nosotros podemos rescindir este acuerdo en cualquier momento y por cualquier motivo mediante notificación
     por escrito (incluido correo electrónico). Antes de rescindir, debe pagar cualquier factura impaga (si existe). Una vez
     rescindido el acuerdo, eliminaremos permanentemente su cuenta y todos los datos asociados con ella.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Cambios a los Términos de uso</h6>
    <p className="mb-0 ps-3">
     Podemos cambiar los Términos de uso en cualquier momento y publicarlos en nuestro sitio web, así como notificarlo mediante
     correo electrónico a la dirección que proporcionó. A menos que cancele su cuenta dentro de los 7 días siguientes a dicha
     notificación, los nuevos Términos entrarán en vigor inmediatamente. También podemos cambiar el sitio web, el servicio o
     cualquier característica del servicio en cualquier momento.
    </p>
    <hr className="my-4f" />
    <h6 className="text-primary">Cuenta y contraseña</h6>
    <p className="mb-0 ps-3">
     Es su responsabilidad mantener la confidencialidad de su nombre de usuario y contraseña. También es responsable de cualquier
     uso de su cuenta, ya sea autorizado o no. Debe notificarnos de inmediato cualquier uso no autorizado de su cuenta. No somos
     responsables por ninguna pérdida debido a contraseñas robadas o pirateadas. Solo podemos restablecer su contraseña por
     motivos de seguridad.
    </p>
   </Card.Body>
  </Card>
 );
});

export default Account;
